import {
  getAuth,
  isSignInWithEmailLink as firebaseIsSignInWithEmailLink,
} from "firebase/auth";

const isSignInWithEmailLink = () => {
  const auth = getAuth();

  return firebaseIsSignInWithEmailLink(auth, window.location.href);
};

export default isSignInWithEmailLink;
